<script>
import Vue from "vue";
import axios from "axios";
import Service from "../../../../service/Service";
import addDialog from "./addDialog";
import deleteDialog from "../../../../dialogs/DeleteDialog.vue";

export default {
    name: "DatesRangeReport",
    components: { addDialog, deleteDialog},
    data() {
        return {
            ENTITY: 'report',
            loading: true,
            isDialogAdd: false,
            isDialogDelete: false,
            selectedItems:[],
            data: [],
            adminSystemDate: [],
            columns: [
                {field: "id", header: "מזהה", type: "string", editable: false},
                {field: "displayName", header: "שם תצוגה", type: "string", editable: true},
                {field: "startDate", header: "תאריך התחלה", type: "date", editable: true},
                {field: "endDate", header: "תאריך סיום", type: "date", editable: true},
                {field: "forAdminOnly", header: "למנהל בלבד", type: "checkbox", editable: true},
                {field: "forOldShow", header: "להצגה כהשוואה", type: "checkbox", editable: true},
            ],

        }
    },
    async created() {
        const service = new Service()
        const data = await service.gerReportDates()
        this.loading = false
        this.data = data
        this.initAdminSystemDate()
    },
    methods: {
        async onCellEditComplete(event) {
            try {
                let objToSend = {}
                if (this.itemAfterEditing?.id === undefined) {
                    objToSend = event.data

                } else {
                    const index = this.data.findIndex(
                        (item) => item.id === this.itemAfterEditing.id
                    );
                    this.data[index] = this.itemAfterEditing;
                    Vue.set(this.data, index, this.itemAfterEditing);
                    objToSend = JSON.parse(JSON.stringify(this.itemAfterEditing));
                    console.log(this.itemAfterEditing)
                }

                if (!objToSend.id) throw "error"
                await axios.put(`${this.ENTITY}/update-ranges`, objToSend)
                this.openNotification(
                    "success",
                    `מעולה`,
                    `רשומה התעדכנה`
                )
            } catch (e) {
                console.log(e)
                this.openNotification(
                    "danger",
                    `אופס`,
                    `${e} : רשומה לא התעדכנה`
                );
            }
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        rowClass(data) {
            return data.forAdminOnly === true || data.forOldShow === true ? "row-gray" : null;
        },
        addItem(daterange){
            this.data = [...this.data, daterange]
        },
        async deleteItem() {
            const service = new Service()
            try {
                const dateRanges = await service.deleteReportDates(this.selectedItems)
                this.openNotification("success", `מעולה`, `מחקנו ${this.selectedItems.length}  רשומות מהמערכת`);
                location.reload();
            } catch (e) {
                this.openNotification("error", `אופס`, `לא הצלחנו למחוק`);

            }

        },
        initAdminSystemDate(){
            this.adminSystemDate[0] = new Date(Vue.ls.get('startDateDefaultRequest', null))
           this.adminSystemDate[1] = new Date(Vue.ls.get('endDateDefaultRequest', null))
        },
        updateAdminSystemDate(event) {
            if (event[1]){
                const startDate =  event[0].getTime()
                const endDate =  event[1].getTime()
                Vue.ls.set('startDateDefaultRequest',startDate)
                Vue.ls.set('endDateDefaultRequest', endDate)
                axios.defaults.headers.common['startDate'] =  startDate
                axios.defaults.headers.common['endDate'] =  endDate
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
    },
}
</script>

<template>
<div>
    <DataTable
            :rowClass="rowClass"
            :value="data"
            :selection.sync="selectedRows"
            @cell-edit-complete="onCellEditComplete"
            columnResizeMode="fit"
            dataKey="id"
            stateStorage="local"
            stateKey="system-messages-data-state"
            editMode="cell"
            :loading="loading"
            sortField="createdAt"
            :sortOrder="-1"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
    >
        <!-- header -->

        <template #header>
            <div class="p-p-2 table-header">
                <div class="p-m-1 p-d-inline-flex">
                    <h1 style="text-align: center">זמני תעודות</h1>
                </div>

                <div class="p-d-flex">

                    <Button
                            v-tooltip.top="'מחיקה'"
                            v-if="selectedRows.length > 0"
                            icon="pi pi-trash"
                            class="p-mr-2 p-button-danger"
                            @click="isDialogDelete = true"
                    />
                    <Button
                            v-tooltip.top="'הוספה'"
                            icon="pi pi-plus"
                            class="p-mr-2 p-button-success"
                            @click="isDialogAdd = true"
                    />
                </div>
            </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

        <!-- v-for -->
        <Column
                headerStyle="text-align: rtl"
                bodyStyle="text-align: right; overflow: scroll"
                v-for="col of columns"
                :field="col.field"
                :header="col.header"
        >
            <template #body="slotProps">
                <div v-if="col.type === 'string'">
                    {{ slotProps.data[col.field] }}
                </div>
                <div v-if="col.type === 'number'">
                    {{ slotProps.data[col.field] }}
                </div>
                <div v-if="col.type === 'subject'">
                    {{ getLessonName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'grade'">
                    {{ getGradeName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'date'">
                    {{ new Date(slotProps.data[col.field]).toLocaleDateString() }}
                </div>
                <div v-if="col.type === 'user'">
                    {{ getTeacherName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'checkbox'">
                    <checkbox
                            @input="onCellEdit($event, slotProps)"

                            v-model="slotProps.data[col.field]"
                            :binary="true"/>
                </div>
            </template>

            <template v-if="col.editable " #editor="slotProps">
                <div v-if="col.type === 'string'">
                    <InputText
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'number'">
                    <InputNumber
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'subject'">
                    <select-lesson  v-on:onSelect="onCellEdit($event.id, slotProps)" :defaultValue="slotProps.data[slotProps.column.field].id"/>
                </div>
                <div v-if="col.type === 'checkbox'">
                    <checkbox
                            @input="onCellEdit($event, slotProps)"

                            v-model="slotProps.data[slotProps.column.field]" :binary="true"></checkbox>

                </div>
                <div v-if="col.type === 'date'">
                    <Calendar
                            @input="onCellEdit($event, slotProps)"
                            shouldReturnLong
                            :touchUI="true"
                            :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data[slotProps.column.field])" />
                </div>
            </template>
        </Column>
        <!-- v-for -->

        <template #footer>
            סה״כ {{ data ? data.length : 0 }} רשומות.
        </template>
    </DataTable>
    <add-dialog
            :show="isDialogAdd"
            v-on:addItem="addItem"
            v-on:closeDialog="isDialogAdd = false"
    />
    <delete-dialog
            :title="'מחיקה'"
            :context="`האם תרצה להסיר  ${selectedItems.length}רשומות מהמערכת?`"
            :show="isDialogDelete"
            v-on:choice="deleteItem"
    />
</div>
</template>


<style scoped>
>>>.row-gray{
    background-color: #e7e7e7 !important;;
}
</style>
